import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=56bb3cde&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=56bb3cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb3cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bb3cde')) {
      api.createRecord('56bb3cde', component.options)
    } else {
      api.reload('56bb3cde', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=56bb3cde&scoped=true&", function () {
      api.rerender('56bb3cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lzx6Yoi3EHt2/JS/comp/PopupDialog.vue"
export default component.exports